module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kiwi-userbox"
  }, [_c('div', {
    staticClass: "kiwi-userbox-header"
  }, [_c('i', {
    staticClass: "fa fa-user kiwi-userbox-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.user.nick))]), _vm._v(" "), _c('div', {
    staticClass: "kiwi-userbox-usermask"
  }, [_vm._v(_vm._s(_vm.user.username) + "@" + _vm._s(_vm.user.host))])]), _vm._v(" "), _c('p', {
    staticClass: "kiwi-userbox-basicinfo"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('whois_realname')) + ":")]), _vm._v(" " + _vm._s(_vm.user.realname) + " "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t('whois_status')) + ":")]), _vm._v(" " + _vm._s(_vm.user.away ? _vm.user.away : _vm.$t('whois_status_available')) + " "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "kiwi-userbox-actions"
  }, [_c('a', {
    staticClass: "u-link",
    on: {
      "click": _vm.openQuery
    }
  }, [_vm._v(_vm._s(_vm.$t('send_a_message')))]), _vm._v(" "), (!_vm.whoisRequested) ? _c('a', {
    staticClass: "u-link",
    on: {
      "click": _vm.updateWhoisData
    }
  }, [_vm._v(_vm._s(_vm.$t('more_information')))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.ignore),
      expression: "user.ignore"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.user.ignore) ? _vm._i(_vm.user.ignore, null) > -1 : (_vm.user.ignore)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.user.ignore,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.user.ignore = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.user.ignore = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.user.ignore = $$c
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('ignore_user')) + "\n        ")])]), _vm._v(" "), (_vm.whoisRequested) ? _c('div', {
    staticClass: "kiwi-userbox-whois",
    class: [_vm.whoisLoading ? 'kiwi-userbox-whois--loading' : '']
  }, [(_vm.whoisLoading) ? [_c('i', {
    staticClass: "fa fa-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  })] : [_c('span', {
    staticClass: "kiwi-userbox-whois-line"
  }, [_vm._v(_vm._s(_vm.user.away ? _vm.$t('whois_status') + ': ' + _vm.user.away : _vm.$t('whois_status_available')))]), _vm._v(" "), (_vm.user.account) ? _c('span', {
    staticClass: "kiwi-userbox-whois-line"
  }, [_vm._v(_vm._s(_vm.$t('user_account', {
    user: _vm.user.account
  })))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "kiwi-userbox-whois-line"
  }, [_vm._v(_vm._s(_vm.$t('user_realname', {
    realname: _vm.user.realname
  })))]), _vm._v(" "), (_vm.user.bot) ? _c('span', {
    staticClass: "kiwi-userbox-whois-line"
  }, [_vm._v(_vm._s(_vm.$t('user_bot')))]) : _vm._e(), _vm._v(" "), (_vm.user.helpop) ? _c('span', {
    staticClass: "kiwi-userbox-whois-line"
  }, [_vm._v(_vm._s(_vm.$t('user_help')))]) : _vm._e(), _vm._v(" "), (_vm.user.operator) ? _c('span', {
    staticClass: "kiwi-userbox-whois-line"
  }, [_vm._v(_vm._s(_vm.$t('user_op')))]) : _vm._e(), _vm._v(" "), (_vm.user.server) ? _c('span', {
    staticClass: "kiwi-userbox-whois-line"
  }, [_vm._v(_vm._s(_vm.$t('user_server', {
    server: _vm.user.server,
    info: (_vm.user.server_info ? ("(" + (_vm.user.server_info) + ")") : '')
  })) + "\u000f")]) : _vm._e(), _vm._v(" "), (_vm.user.secure) ? _c('span', {
    staticClass: "kiwi-userbox-whois-line"
  }, [_vm._v(_vm._s(_vm.$t('user_secure')))]) : _vm._e(), _vm._v(" "), (_vm.user.channels) ? _c('span', {
    staticClass: "kiwi-userbox-whois-line"
  }, [_vm._v(_vm._s(_vm.$t('user_channels', {
    channels: _vm.user.channels
  })))]) : _vm._e()]], 2) : _vm._e(), _vm._v(" "), (_vm.buffer.isChannel() && _vm.areWeAnOp) ? _c('div', {
    staticClass: "kiwi-userbox-actions-op"
  }, [_c('form', {
    staticClass: "u-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [(_vm.isUserOnBuffer) ? _c('label', [_vm._v("\n                " + _vm._s(_vm.$t('user_access')) + " "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userMode),
      expression: "userMode"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.userMode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_vm._l((_vm.availableChannelModes), function(mode) {
    return _c('option', {
      domProps: {
        "value": mode.mode
      }
    }, [_vm._v("\n                        " + _vm._s(mode.description) + "\n                    ")])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('user_normal')))])], 2)]) : _vm._e(), _vm._v(" "), (_vm.isUserOnBuffer) ? _c('label', [_c('button', {
    staticClass: "u-button u-button-secondary",
    on: {
      "click": _vm.kickUser
    }
  }, [_vm._v(_vm._s(_vm.$t('user_kick')))])]) : _vm._e(), _vm._v(" "), _c('label', [_c('button', {
    staticClass: "u-button u-button-secondary",
    on: {
      "click": _vm.banUser
    }
  }, [_vm._v(_vm._s(_vm.$t('user_ban')))])]), _vm._v(" "), (_vm.isUserOnBuffer) ? _c('label', [_c('button', {
    staticClass: "u-button u-button-secondary",
    on: {
      "click": _vm.kickbanUser
    }
  }, [_vm._v(_vm._s(_vm.$t('user_kickban')))])]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-65424cf6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserBox.vue
// module id = 492
// module chunks = 2